import React, { Component } from 'react';
//Checked
export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
			diagnosisError: null
		}
	}
	checkDiagnosisCode = (e) => {
		console.log('here');
		fetch(window.location.origin + window.location.pathname + 'checknfsbdiagnosiscode', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.props.navigate('R8')
			} else {
				this.setState({ diagnosisError: await response.text() })
			}
		})
	}
	updateNon_Func_Bowel_Diagnosis = (e) => {
		this.props.setData('Non_Func_Bowel_Diagnosis', e.currentTarget.value.toUpperCase());
		//this.props.setData('EnteredDiagnosisCode', true);
	}

	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<div>
					<p>Enter the diagnosis. No decimal point entry is allowed. Add zeros to the end of the diagnosis code to fulfill the 5-digit requirement.</p>
					<input type="text" value={this.props.data.Non_Func_Bowel_Diagnosis} onChange={this.updateNon_Func_Bowel_Diagnosis} />
					<br />
				</div>
				{(this.state.diagnosisError) ? <div className="error">{this.state.diagnosisError}</div> : ''}
				<div className="button" onClick={this.checkDiagnosisCode}>Continue</div>
			</div>
		);
	}
}